/** @jsxImportSource react */
'use client';

import Link from 'next/link';

import type { ReactNode } from 'react';

import { ONARK_TRAINING_PATH } from '../lib/training';

import { track } from './analytics';

export { ONARK_TRAINING_PATH } from '../lib/training';

/** Client wrapper around the OnArk Training link with attribution tracking. */
export function TrainingLink({
  children,
  className,
  href = ONARK_TRAINING_PATH,
  source,
}: {
  source: string;
  href?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link
      className={className}
      href={href}
      onClick={() => track('training_cta_clicked', { source })}
    >
      {children}
    </Link>
  );
}
